import React from 'react'
import menuItems from './menuItems'
import Edit from '../crud/edit'
import MenuEditor from './MenuEditor'

const fields = [{
  name: 'About Us Menu',
  prop: 'value',
  type: 'component',
  component: MenuEditor,
  componentProps: {
    pageFilter: page => !page.requires_membership
  }
}]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit About Us Menu'
      fields={fields}
      apiPath='admin/settings/about_us_menu'
      successRedirectPath='/settings/about_us_menu'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
